import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from './home/home.component';
import {ExpertkltpComponent} from './expertkltp/expertkltp.component';
import {EventsComponent} from './events/events.component';
import {TehusComponent} from './tehus/tehus.component';
import {ExpertpdComponent} from './expertpd/expertpd.component';
import {ExpprombezComponent} from './expprombez/expprombez.component';
import {ZisComponent} from './zis/zis.component';
import {ExpertdeclComponent} from './expertdecl/expertdecl.component';
import {EpbKotlovComponent} from './epb-kotlov/epb-kotlov.component';
import {EpbSosudovComponent} from './epb-sosudov/epb-sosudov.component';
import {EpbGazoprovodovComponent} from './epb-gazoprovodov/epb-gazoprovodov.component';
import {EpbGpmComponent} from './epb-gpm/epb-gpm.component';
import {TekhDiComponent} from './tekh-di/tekh-di.component';
import {TdGazComponent} from './td-gaz/td-gaz.component';
import {ObRezervuarovComponent} from './ob-rezervuarov/ob-rezervuarov.component';
import {ObKotlovComponent} from './ob-kotlov/ob-kotlov.component';
import {TeplpsetComponent} from './teplpset/teplpset.component';
import {LikOpoComponent} from './lik-opo/lik-opo.component';
import {LikOpoLikComponent} from './lik-opo-lik/lik-opo-lik.component';
import {KonservationComponent} from './konservation/konservation.component';
import {PerevorujComponent} from './perevoruj/perevoruj.component';
import {ContactsComponent} from './contacts/contacts.component';
import {IdentificationComponent} from './identification/identification.component';
import {ObZisComponent} from './ob-zis/ob-zis.component';
import {ObSosudovComponent} from './ob-sosudov/ob-sosudov.component';
import {ObTrubComponent} from './ob-trub/ob-trub.component';
import {ObGpmComponent} from './ob-gpm/ob-gpm.component';
import {AuditComponent} from './audit/audit.component';
import {PasportComponent} from './pasport/pasport.component';
import {OtzyvyComponent} from './otzyvy/otzyvy.component';
import {AboutComponent} from './about/about.component';
import {EachOtzyvComponent} from "./otzyvy/each-otzyv/each-otzyv.component";

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'expertkltp',
    component: ExpertkltpComponent
  },
  {
    path: 'expprombez',
    component: ExpprombezComponent
  },
  {
    path: 'expprombez/tehus',
    component: TehusComponent
  },
  {
    path: 'expprombez/zis',
    component: ZisComponent
  },
  {
    path: 'expprombez/expertpd',
    component: ExpertpdComponent
  },
  {
    path: 'expprombez/expertdecl',
    component: ExpertdeclComponent
  },
  {
    path: 'expprombez/epb-kotlov',
    component: EpbKotlovComponent
  },
  {
    path: 'expprombez/epb-sosudov',
    component: EpbSosudovComponent
  },
  {
    path: 'expprombez/epb-gazoprovodov',
    component: EpbGazoprovodovComponent
  },
  {
    path: 'expprombez/epb-gpm',
    component: EpbGpmComponent
  },
  {
    path: 'tekhnicheskoe-diagnostirovanie',
    component: TekhDiComponent
  },
  {
    path: 'tekhnicheskoe-diagnostirovanie/td-gaz',
    component: TdGazComponent
  },
  {
    path: 'events',
    component: EventsComponent
  },
  {
    path: 'tekhnicheskoe-diagnostirovanie/obsledovanie-rezervuarov',
    component: ObRezervuarovComponent
  },
  {
    path: 'tekhnicheskoe-diagnostirovanie/obsledovanie-kotlov',
    component: ObKotlovComponent
  },
  {
    path: 'expprombez/teplpset',
    component: TeplpsetComponent
  },
  {
    path: 'proekt-likvidatsii-i-konservatsii-opo',
    component: LikOpoComponent
  },
  {
    path: 'proekt-likvidatsii-i-konservatsii-opo/likvidatsiya',
    component: LikOpoLikComponent
  },
  {
    path: 'proekt-likvidatsii-i-konservatsii-opo/konservatsiya',
    component: KonservationComponent
  },
  {
    path: 'tehnicheskoe-perevooruzhenie-opo',
    component: PerevorujComponent
  },
  {
    path: 'contacts',
    component: ContactsComponent
  },
  {
    path: 'identifikaciya',
    component: IdentificationComponent
  },
  {
    path: 'tekhnicheskoe-diagnostirovanie/obsledovanie-zis',
    component: ObZisComponent
  },
  {
    path: 'tekhnicheskoe-diagnostirovanie/obsledovanie-sosudov',
    component: ObSosudovComponent
  },
  {
    path: 'tekhnicheskoe-diagnostirovanie/obsledovanie-truboprovodov',
    component: ObTrubComponent
  },
  {
    path: 'tekhnicheskoe-diagnostirovanie/obsledovanie-gpm',
    component: ObGpmComponent
  },
  {
    path: 'audit',
    component: AuditComponent
  },
  {
    path: 'pasport',
    component: PasportComponent
  },
  {
    path: 'otzyvy',
    component: OtzyvyComponent
  },
  {
    path: 'otzyvy/:id',
    component: EachOtzyvComponent
  },
  {
    path: 'about',
    component: AboutComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
